// src/pages/UnauthorizedPage.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import AnanasPolice from "../images/stoppineapple.png";
import Button from "../components/controls/Button";

export default function UnauthorizedPage() {
  const { t } = useTranslation();

  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-b from-[#fff7e6] to-white">
      <section className="w-full max-w-md text-center">
        {/* Image + halo pulse pro */}
        <div className="relative mx-auto w-44 sm:w-56 aspect-square">
          {/* halo doux */}
          <div className="absolute inset-0 rounded-full bg-[#fff3af] blur-2xl opacity-70 animate-pulse" />
          {/* léger ring en ping */}
          <div className="absolute inset-0 rounded-full border border-[#94d3cc] opacity-40 animate-ping" />
          <img
            src={AnanasPolice}
            alt={t("unauthorized.imageAlt")}
            className="relative z-10 w-full h-full object-contain drop-shadow"
          />
        </div>

        <h1 className="mt-6 text-3xl font-bold" style={{ color: "#C85A2C" }}>
          {t("unauthorized.title")}
        </h1>

        <p
          className="mt-3 text-base leading-relaxed"
          style={{ color: "#B35C38" }}
        >
          {t("unauthorized.subtitle")}
        </p>

        <div className="mt-6 space-y-3">
          <p className="text-sm opacity-80">{t("unauthorized.description")}</p>

          <div className="mt-4 flex flex-col sm:flex-row gap-3 justify-center">
            <Button as="a" size="lg" href="/" fullWidth className="sm:w-auto">
              {t("unauthorized.cta.home")}
            </Button>

            <Button
              as="a"
              size="lg"
              href="/login"
              fullWidth
              className="sm:w-auto"
            >
              {t("unauthorized.cta.login")}
            </Button>
          </div>
        </div>

        <p className="mt-6 text-xs opacity-60">{t("unauthorized.help")}</p>
      </section>
    </main>
  );
}
